import { useMutation, useQuery } from "react-query"
import { GallopData } from "../api/gallopData"
import { TSchedule } from "../shared/types/schedule.type"
import { hydraTransform } from "../shared/utils/hydraTransformer"

type UseGallopData = {
    options?: string[],
    gallopDataQueryEnabled?: boolean
}

export const useGallopData = ({ options = [], gallopDataQueryEnabled = false }: UseGallopData) => {

    const gallopDataQuery = useQuery(['gallop_review_data', JSON.stringify(options)], () => GallopData.getGalopReviewData(options), {
        enabled: gallopDataQueryEnabled
    })

    //CRUD MUTATIONS
    const saveConfigMutation = useMutation((data: Partial<TSchedule>) => GallopData.saveConfig(data))

    const deleteConfigMutation = useMutation((id: number) => GallopData.deleteConfig(id))

    const updateConfigMutation = useMutation(({ id, config }: { id: number, config: Partial<TSchedule> }) => GallopData.updateConfig(id, config))


    const generateSchedulePhraseMutation = useMutation((data: Partial<TSchedule>) => GallopData.generatePhrase(data))


    return {
        saveGallopReview: saveConfigMutation,
        deleteGallopReview: deleteConfigMutation,
        updateGallopReview: updateConfigMutation,
        generateGallopPhrase: generateSchedulePhraseMutation,
        data: gallopDataQuery.data?.data,
        isLoadingGallopData:gallopDataQuery.isLoading
    }
}